import React, { useState, useEffect } from "react";
import "../styles/Franchise.css";
// Importing assets from the project
import heroBg from "../images/franchise1.mp4";
import retail from "../images/retail.jpeg";
import branding from "../images/branding.jpeg";
import marketing from "../images/strong network.jpeg";

import {
  FaLeaf,
  FaFlask,
  FaWater,
  FaTractor,
  FaWarehouse,
  FaCreditCard,
  FaCoins,
  FaChartLine,
  FaCheckCircle
} from "react-icons/fa";
import { useLang } from "../components/LangContext";

const Franchise = () => {
  const { t } = useLang();
  // Scroll to top on mount (fixes navigation issue)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    city: "",
    investment: "",
    message: ""
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const payload = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      city: formData.city,
      investment: formData.investment,
      message: formData.message
    };

    try {
      const response = await fetch("https://admin.agrifabrix.in/api/static/Franchise", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (response.ok) {
        alert(t("franchise_alert_success"));
        setFormData({ name: "", email: "", phone: "", city: "", investment: "", message: "" });
      } else {
        alert(data.error || t("franchise_alert_failed"));
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert(t("franchise_alert_error") || "Network error. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="franchise-page">
      {/* HERO SECTION */}
      {/* HERO SECTION - Matched with Sustainability Format */}
      <section className="sus-hero">
        <video
          className="sus-video"
          src={heroBg}
          autoPlay
          loop
          muted
          playsInline
        />
        <div className="sus-overlay"></div>
        <div className="sus-hero-content">
          <h1 className="sus-hero-title">{t("franchise_hero_title")}</h1>
          <p className="sus-hero-desc" style={{ fontWeight: 'bold' }}>{t("franchise_hero_desc")}</p>
          <a href="#leads-form" className="hero-cta-button" style={{ marginTop: '20px' }}>
            {t("franchise_hero_cta")}
          </a>
        </div>
      </section>
      {/* IDEAL FRANCHISE PARTNER */}

      <section className="franchise-section">
        <div className="section-container">

          <h2 className="section-title">{t("franchise_partner_title")}</h2>
          <p className="section-subtitle">{t("franchise_partner_subtitle")}</p>

          {/* Row 1 */}
          <div className="feature-row">

            <div className="feature-box image-box">
              <img
                src="https://media.istockphoto.com/id/1316735334/photo/young-indian-farmer-with-agronomist-at-banana-field.jpg?s=612x612&w=0&k=20&c=SjD-Bi-oO9LsYUSB69Jphal7nB-DySGiwLb8aDnw8UI="
                alt="Agri Professional"
              />
            </div>

            <div className="feature-box content-box">
              <span className="highlight-text">
                {t("franchise_partner_prof_title")}
              </span>
              <p>{t("franchise_partner_prof_desc")}</p>
            </div>

          </div>


          {/* Row 2 */}
          <div className="feature-row reverse">

            <div className="feature-box image-box">
              <img
                src="https://www.balavikasa.org/uploads/blogs/1500-organic-farmers-gather-for-monthly-meetings-on-organic-farming-practices193.jpg"
                alt="Strong Network"
              />
            </div>

            <div className="feature-box content-box">
              <span className="highlight-text">
                {t("franchise_partner_net_title")}
              </span>
              <p>{t("franchise_partner_net_desc")}</p>
            </div>

          </div>


          {/* Row 3 */}
          <div className="feature-row">

            <div className="feature-box image-box">
              <img
                src={retail}
                alt="Retail Ready"
              />
            </div>

            <div className="feature-box content-box">
              <span className="highlight-text">
                {t("franchise_partner_retail_title")}
              </span>
              <p>{t("franchise_partner_retail_desc")}</p>
            </div>

          </div>


          {/* Row 4 */}
          <div className="feature-row reverse">

            <div className="feature-box image-box">
              <img
                src="https://th-i.thgim.com/public/incoming/wp5hlb/article70715309.ece/alternates/FREE_1200/10215_7_3_2026_12_40_41_1_IMG_20260307_WA0085.JPG"
                alt="Compliance"
              />
            </div>

            <div className="feature-box content-box">
              <span className="highlight-text">
                {t("franchise_partner_comp_title")}
              </span>
              <p>{t("franchise_partner_comp_desc")}</p>
            </div>

          </div>

        </div>
      </section>



      <section className="franchise-section">
        <div className="section-container">
          <h2>{t("franchise_scope_title")}</h2>
          <p className="section-subtitle">{t("franchise_scope_subtitle")}</p>

          <div className="grid-3">

            <div className="service-card">
              <div className="icon-wrapper"><FaLeaf /></div>
              <h4>{t("franchise_scope_input_title")}</h4>
              <p>{t("franchise_scope_input_desc")}</p>
            </div>

            <div className="service-card">
              <div className="icon-wrapper"><FaFlask /></div>
              <h4>{t("franchise_scope_advisory_title")}</h4>
              <p>{t("franchise_scope_advisory_desc")}</p>
            </div>

            <div className="service-card">
              <div className="icon-wrapper"><FaWater /></div>
              <h4>{t("franchise_scope_irrigation_title")}</h4>
              <p>{t("franchise_scope_irrigation_desc")}</p>
            </div>

            <div className="service-card">
              <div className="icon-wrapper"><FaTractor /></div>
              <h4>{t("franchise_scope_machinery_title")}</h4>
              <p>{t("franchise_scope_machinery_desc")}</p>
            </div>

            <div className="service-card">
              <div className="icon-wrapper"><FaWarehouse /></div>
              <h4>{t("franchise_scope_harvest_title")}</h4>
              <p>{t("franchise_scope_harvest_desc")}</p>
            </div>

            <div className="service-card">
              <div className="icon-wrapper"><FaCreditCard /></div>
              <h4>{t("franchise_scope_finance_title")}</h4>
              <p>{t("franchise_scope_finance_desc")}</p>
            </div>

          </div>
        </div>
      </section>

      {/* PERKS & BENEFITS */}
      <section className="perks-section">
        <div className="section-container">

          <h2 className="perks-title">
            {t("franchise_perks_title")}
          </h2>

          <p className="section-subtitle">
            {t("franchise_perks_subtitle")}
          </p>

          <div className="perks-grid">

            {/* Brand Support */}
            <div className="perks-card">
              <img
                src={branding}
                alt="Farmer Partnership"
              />
              <h3>{t("franchise_perks_brand_title")}</h3>
              <p>{t("franchise_perks_brand_desc")}</p>
            </div>

            {/* Supply Chain */}
            <div className="perks-card">
              <img
                src="https://content.jdmagicbox.com/comp/def_content/warehouses-for-food-products/warehouses-for-food-products-5-warehouses-for-food-products-5-lk8r4.jpg"
                alt="Agriculture Warehouse"
              />
              <h3>{t("franchise_perks_supply_title")}</h3>
              <p>{t("franchise_perks_supply_desc")}</p>
            </div>

            {/* Training */}
            <div className="perks-card">
              <img
                src="https://cdn.assets.prezly.com/fb68b75b-7558-4590-8737-ae8e60f9ac96/IMG_2969.jpeg"
                alt="Farmer Training"
              />
              <h3>{t("franchise_perks_training_title")}</h3>
              <p>{t("franchise_perks_training_desc")}</p>
            </div>

            {/* Marketing */}
            <div className="perks-card">
              <img
                src={marketing}
                alt="Agri Product Promotion"
              />
              <h3>{t("franchise_perks_marketing_title")}</h3>
              <p>{t("franchise_perks_marketing_desc")}</p>
            </div>

          </div>

        </div>
      </section>
      {/* TECHNOLOGY SECTION (Preserved) */}
      <section className="franchise-ai-tech">
        <div className="section-container ai-tech-container">
          <div className="ai-image">
            <img src={require("../images/farmer_with_drone.png")} alt="Modern Banana Farming" />
          </div>
          <div className="ai-content">
            <h2>{t("franchise_tech_title")}</h2>
            <p>{t("franchise_tech_desc")}</p>
            <ul>
              <li><FaLeaf color="#28a745" /> <span>{t("franchise_tech_li1")}</span></li>
              <li><FaCoins color="#28a745" /> <span>{t("franchise_tech_li2")}</span></li>
              <li><FaChartLine color="#28a745" /> <span>{t("franchise_tech_li3")}</span></li>
              <li><FaCheckCircle color="#28a745" /> <span>{t("franchise_tech_li4")}</span></li>
            </ul>
          </div>
        </div>
      </section>


      {/* 5. APPLICATION PROCESS */}
      <section className="franchise-section">
        <div className="section-container">
          <h2>{t("franchise_process_title")}</h2>
          <div className="process-steps">
            <div className="process-step">
              <div className="step-num">1</div>
              <h4>{t("franchise_process_step1_title")}</h4>
              <p>{t("franchise_process_step1_desc")}</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-num">2</div>
              <h4>{t("franchise_process_step2_title")}</h4>
              <p>{t("franchise_process_step2_desc")}</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-num">3</div>
              <h4>{t("franchise_process_step3_title")}</h4>
              <p>{t("franchise_process_step3_desc")}</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-num">4</div>
              <h4>{t("franchise_process_step4_title")}</h4>
              <p>{t("franchise_process_step4_desc")}</p>
            </div>
            <div className="process-connector"></div>
            <div className="process-step">
              <div className="step-num highlight">5</div>
              <h4>{t("franchise_process_step5_title")}</h4>
              <p>{t("franchise_process_step5_desc")}</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="franchise-faq">
        <h2>{t("franchise_faq_title")}</h2>
        <div className="faq-item">
          <h3>{t("franchise_faq_q1")}</h3>
          <p>{t("franchise_faq_a1")}</p>
        </div>
        <div className="faq-item">
          <h3>{t("franchise_faq_q2")}</h3>
          <p>{t("franchise_faq_a2")}</p>
        </div>
        <div className="faq-item">
          <h3>{t("franchise_faq_q3")}</h3>
          <p>{t("franchise_faq_a3")}</p>
        </div>
      </section>

      {/* APPLICATION FORM */}
      <section id="leads-form" className="franchise-application">
        <h2>{t("franchise_form_title")}</h2>
        <p>{t("franchise_form_subtitle")}</p>

        <form className="application-form" onSubmit={handleSubmit}>

          <div className="form-group">
            <label>{t("franchise_form_name")}</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder={t("franchise_form_name_placeholder")}
            />
          </div>

          <div className="form-group">
            <label>{t("franchise_form_email")}</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder={t("franchise_form_email_placeholder")}
            />
          </div>

          <div className="form-group">
            <label>{t("franchise_form_phone")}</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
              placeholder={t("franchise_form_phone_placeholder")}
            />
          </div>

          <div className="form-group">
            <label>{t("franchise_form_location")}</label>
            <input
              type="text"
              name="city"
              value={formData.city}
              onChange={handleChange}
              required
              placeholder={t("franchise_form_location_placeholder")}
            />
          </div>

          <div className="form-group">
            <label>{t("franchise_form_investment")}</label>
            <select name="investment" value={formData.investment} onChange={handleChange} required>
              <option value="">{t("franchise_form_investment_placeholder")}</option>
              <option value="5-10 Lakhs">₹5 - ₹10 Lakhs</option>
              <option value="10-15 Lakhs">₹10 - ₹15 Lakhs</option>
              <option value="15-25 Lakhs">₹15 - ₹25 Lakhs</option>
              <option value="25+ Lakhs">₹25 Lakhs+</option>
            </select>
          </div>

          <div className="form-group">
            <label>{t("franchise_form_message")}</label>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder={t("franchise_form_message_placeholder")}
              rows="4"
            ></textarea>
          </div>

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? t("franchise_form_submitting") : t("franchise_form_submit")}
          </button>

        </form>
      </section>
    </div>
  );
};

export default Franchise;
